import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HumanReservation, HumanUtilizationParams, Reservation } from '@app/interfaces/reservation/human-reservation';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HumanReservationService {
    private baseUrl = environment.api.services.reservation + '/human-reservation';

    constructor(private http: HttpClient) {
    }

    async getHumanUtilization(data: HumanUtilizationParams): Promise<HumanReservation[]> {
        return lastValueFrom(this.http.post<HumanReservation[]>(`${this.baseUrl}/human/utilization`, data));
    }

    async findHumanList(data: HumanUtilizationParams): Promise<Reservation[]> {
        return lastValueFrom(this.http.post<Reservation[]>(`${this.baseUrl}/human/list`, data));
    }
}
